export interface EventPathEntry {
  collection: string;
  recordId: string;
}

const OBJECT_ID = /^[0-9a-f]{24}$/i;

// React Router already decodes the splat, so decoding a Mongo id again is a
// no-op. The decode stays for collection names with escapes and for a path
// that reaches this parser undecoded.
const decode = (part: string): string | null => {
  try {
    return decodeURIComponent(part).trim();
  } catch {
    return null;
  }
};

/** The `<collection>/<recordId>` pairs after the event id, as legacy writes them. */
export const parseEventPath = (splat: string | undefined): EventPathEntry[] => {
  const parts = (splat ?? "").split("/").map(decode);
  if (parts.some(part => part === null)) return [];
  const clean = (parts as string[]).filter(Boolean);
  const out: EventPathEntry[] = [];
  for (let i = 0; i + 1 < clean.length; i += 2) {
    if (OBJECT_ID.test(clean[i + 1])) {
      out.push({ collection: clean[i], recordId: clean[i + 1] });
    } else {
      // Not a pair: realign on the next element.
      i -= 1;
    }
  }
  return out;
};

export const eventsListPath = (canvasId: string): string =>
  `/sample-trackers/${canvasId}/events`;

export const eventRunnerPath = (
  canvasId: string,
  eventId: string,
  path: EventPathEntry[] = []
): string =>
  [
    `${eventsListPath(canvasId)}/${eventId}`,
    ...path.flatMap(p => [encodeURIComponent(p.collection), p.recordId]),
  ].join("/");
